/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StripeProvider, Elements } from 'react-stripe-elements';

import InjectedCheckoutForm from './InjectedForm';
import Headers from './Headers';
import LineItem from './LineItem';
import { gtag } from '../Analytics/gtag';
import { getPowerSubscriptionDetails } from '../../api/checkoutApi';

import { fetchTrialContent } from '../../actions/trial-availability-actions';
import {
    submitMemberCheckout,
    submitClubCheckout,
    updatePaymentDetails,
    submitEnterpriseClubCheckout,
} from '../../actions/checkout-subscription-actions';

import { stripePlans } from '../../utils/constants';
import { getApiAxiosInstance } from '../../utils/network';
import config from '../../../config';

import styles from './checkoutForm.scss';

class CheckoutForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stripe: null,
            success: false,
            couponCode: false,
            couponError: '',
            successText: 'You\'re all set!',
            // eslint-disable-next-line todo-comments/todo-comments
            // TODO (davecohen): Remove this and related code with HUB-526
            shouldSaveCard: false,
            isUsingStripeForm: false,
            invoiceItems: null,
            isPaymentByDefaultCard: true,
        };

        this.handleCheckout = this.handleCheckout.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.applyCoupon = this.applyCoupon.bind(this);

        // eslint-disable-next-line todo-comments/todo-comments
        // TODO (davecohen): Remove this and related code with HUB-526
        this.saveCardEnabled = false;
    }

    componentDidMount() {
        if (window.Stripe) {
            this.setState({ stripe: window.Stripe(config.stripeKey) });
        } else {
            document.querySelector('#stripe-js').addEventListener('load', () => {
                // Create Stripe instance once Stripe.js loads
                this.setState({
                    stripe: window.Stripe(config.stripeKey),
                });
            });
        }

        this.getLineItem(this.props.couponCode);
    }

    componentDidUpdate(oldProps) {
        if (this.props.onUpdate) { this.props.onUpdate(); }
        if (oldProps.interval !== this.props.interval) {
            this.getLineItem(this.props.couponCode);
        }
    }

    onComplete(paymentMethodId) {
        const { formType } = this.props;
        let category = 'subscription upgrade';
        let path = '/upgrade';
        let title = formType;

        switch (formType) {
            case 'powered':
                category = 'power upgrade';
                path = '/upgrade/power';
                title = 'power upgrade';
                break;
            case 'pro_club_college':
                category = 'college upgrade';
                path = '/upgrade/college';
                title = 'college upgrade';
                break;
            case 'performance_hs_club':
                category = 'highschool upgrade';
                path = '/upgrade/highschool';
                title = 'highschool upgrade';
                break;
            default:
                break;
        }

        if (window?.analytics) {
            const properties = {
                path,
                url: path,
                title,
            };

            window.analytics.page(category, 'subscription upgrade', properties);
        }

        const { total } = this.state?.invoiceItems || {};
        gtag('purchase', {
            value: total?.amount,
            transaction_id: paymentMethodId,
            category: 'Subscription Upgrade',
            context: category,
        });
        // commenting out for now in case we will return back to the facebook pixel for purchase tracking
        // if (window && window.fbq) {
        //     window.fbq('track', 'Purchase', { value: total?.amount, currency: total?.currency, content_name: category });
        // }
        if (window?.pixie) {
            window.pixie('event', 'Powerplayers');
        }

        this.props.onComplete(paymentMethodId);
    }

    getButtonText(formType) {
        if (formType === 'powered') {
            return 'Upgrade to Power';
        }
        if (formType === 'pro_club' || formType === 'pro_club_create') {
            return 'Upgrade to Pro Club';
        }
        if (formType === 'cc_update') {
            return 'Update';
        }
        if (formType === 'pro_club_college') {
            return 'Upgrade to College Coach Subscription';
        }
        if (formType === 'performance_hs_club') {
            return 'Upgrade';
        }
        return 'Submit';
    }

    async getLineItem(couponCode) {
        const { formType, interval } = this.props;
        let item = null;
        if (formType === 'powered') {
            this.setState({
                couponCode,
            });
            if (interval === 'month') {
                this.props.fetchTrialContent('power_monthly_v1');
            }
            if (interval === 'year') {
                this.props.fetchTrialContent('power_annual_v1');
            }
            const resp = await getPowerSubscriptionDetails(getApiAxiosInstance(), {
                plan: (interval === 'month') ? stripePlans.members.powerMonthly : stripePlans.members.powerAnnual,
                couponCode,
            });
            if (resp.data.status === 'success') {
                this.setState({
                    invoiceItems: resp.data.data,
                });
                if (!couponCode) {
                    this.setState({
                        couponCode: false,
                        couponError: '',
                    });
                }
            } else {
                this.setState({
                    couponCode: false,
                    couponError: resp.data.message || '',
                });
            }
            return;
        }
        if (formType === 'pro_club' || formType === 'pro_club_create') {
            item = {
                amount: 149,
                itemName: 'Pro Club Annual',
            };
        }
        if (formType === 'pro_club_college') {
            this.props.fetchTrialContent('proclub_college_discounted_annual_v1');
            item = {
                amount: 149,
                itemName: 'UTR Sports College Annual',
            };

            const resp = await getPowerSubscriptionDetails(getApiAxiosInstance(), { //  'proclub_college_discounted_annual_v1',
                plan: stripePlans.clubs.proCollege,
                couponCode,
            });
            if (resp.data.status === 'success') {
                this.setState({
                    invoiceItems: resp.data.data,
                });
                if (!couponCode) {
                    this.setState({
                        couponCode: false,
                        couponError: '',
                    });
                }
            } else {
                this.setState({
                    couponCode: false,
                    couponError: resp.data.message || '',
                });
            }
        }
        if (formType === 'performance_hs_club') {
            this.props.fetchTrialContent('performance_hs_club');
            item = {
                amount: 75,
                itemName: 'Performance High School',
            };

            const resp = await getPowerSubscriptionDetails(getApiAxiosInstance(), {
                plan: stripePlans.clubs.performanceHsClub,
                couponCode,
            });
            if (resp.data.status === 'success') {
                this.setState({
                    invoiceItems: resp.data.data,
                });
                if (!couponCode) {
                    this.setState({
                        couponCode: false,
                        couponError: '',
                    });
                }
            } else {
                this.setState({
                    couponCode: false,
                    couponError: resp.data.message || '',
                });
            }
        }
        if (formType === 'enterprise_club') {
            let itemName;
            switch (this.props.plan) {
                case stripePlans.clubs.premiumMonthly:
                    itemName = 'Premium Club Monthly';
                    break;
                case stripePlans.clubs.premiumAnnual:
                    itemName = 'Premium Club Annual';
                    break;
                case stripePlans.clubs.premiumTenMonthly:
                    itemName = 'Premium Ten Club Monthly';
                    break;
                default:
                    itemName = 'Premium Ten Club Annual';
            }

            item = {
                amount: this.props.plan === stripePlans.clubs.premiumMonthly || this.props.plan === stripePlans.clubs.premiumTenMonthly ? this.props.billingUnits : this.props.billingUnits * 10,
                itemName,
            };
        }

        this.setState({
            lineItem: item,
        });
    }

    getHeaderComponent(formType, titleInfoOnClick, clubName) {
        const { isUsingStripeForm, isPaymentByDefaultCard } = this.state;
        if (formType === 'powered') {
            return <Headers.Powered isUsingStripeForm={isUsingStripeForm} isPaymentByDefaultCard={isPaymentByDefaultCard} />;
        }
        if (formType === 'pro_club' || formType === 'pro_club_create') {
            return <Headers.ProClub />;
        }
        if (formType === 'enterprise_club') {
            return <Headers.EnterpriseClub />;
        }
        if (formType === 'cc_update') {
            return <Headers.CCUpdate isUsingStripeForm={isUsingStripeForm} isPaymentByDefaultCard={isPaymentByDefaultCard} />;
        }
        if (formType === 'pro_club_college') {
            return <Headers.ProClubCollege titleInfoOnClick={titleInfoOnClick} clubName={clubName} />;
        }
        if (formType === 'performance_hs_club') {
            return <Headers.PerformanceHsClub titleInfoOnClick={titleInfoOnClick} clubName={clubName} />;
        }
        return null;
    }

    setUsingStripeForm = isUsingStripeForm => {
        this.setState({ isUsingStripeForm });
    };

    setIsPaymentByDefaultCard = () => {
        this.setState({ isPaymentByDefaultCard: false });
    };

    handleSaveCardChange = isChecked => {
        this.setState({ shouldSaveCard: isChecked });
    };

    handleCheckout(paymentMethodId, isUsingSavedCard = false, isUsingWallet = false, paymentRequestCallBack = null) {
        const data = { subscriptionId: null };
        if (isUsingSavedCard) { // if paying by saved card or by apple/google pay
            data.paymentMethodId = paymentMethodId;
            data.payByWallet = isUsingWallet; // true if paying by apple/google pay
        } else {
            data.paymentMethodId = paymentMethodId;
        }
        const { formType, interval } = this.props;
        const { couponCode, shouldSaveCard } = this.state;
        const isSavingCard = isUsingWallet || isUsingSavedCard ? false : shouldSaveCard;
        if (formType === 'powered') {
            data.plan = interval === 'month' ? stripePlans.members.powerMonthly : stripePlans.members.powerAnnual;
            if (couponCode) {
                data.couponCode = couponCode;
            }
            if (this.saveCardEnabled) {
                data.isSavingCard = isSavingCard;
            }
            this.props.submitMemberCheckout(data).then(() => {
                if (!this.props.subscribe.cardError) {
                    this.setState({ success: true, successText: 'You\'re all set!' }, () => {
                        if (paymentRequestCallBack) { // in case of wallet payment need to close the pop up after payment
                            paymentRequestCallBack.complete('success');
                        }
                    });
                    this.onComplete(paymentMethodId);
                } else if (paymentRequestCallBack) { // in case of wallet payment need to close the pop up after payment
                    paymentRequestCallBack.onComplete('fail');
                }
            });
        }
        if (formType === 'pro_club') {
            data.plan = stripePlans.clubs.pro;
            data.clubId = this.props.clubId;
            this.props.submitClubCheckout({ values: data, stripe: this.state.stripe }).then(() => {
                if (!this.props.subscribe.cardError) {
                    this.setState({ success: true, successText: 'You\'re all set!' });
                    this.onComplete(paymentMethodId);
                }
            });
        }
        if (formType === 'enterprise_club') {
            data.plan = this.props.plan;
            data.clubId = this.props.clubId;
            data.inviteToken = this.props.enterpriseInviteToken;
            this.props.submitEnterpriseClubCheckout({ values: data, stripe: this.state.stripe }).then(() => {
                if (!this.props.subscribe.cardError) {
                    this.setState({ success: true, successText: 'You\'re all set!' });
                    this.onComplete(paymentMethodId);
                }
            });
        }
        if (formType === 'cc_update') {
            data.subscriptionId = this.props.subscriptionId;
            if (this.saveCardEnabled) {
                data.shouldSaveCard = isSavingCard;
            }
            this.props.updatePaymentDetails(data).then(() => {
                if (!this.props.subscribe.cardError) {
                    this.onComplete();
                }
            });
        }
        if (formType === 'pro_club_create') {
            this.onComplete(paymentMethodId);
        }
        if (formType === 'pro_club_college') {
            data.plan = stripePlans.clubs.proCollege;
            data.clubId = this.props.clubId;
            this.props.submitClubCheckout({ values: data, stripe: this.state.stripe }).then(() => {
                if (!this.props.subscribe.cardError) {
                    this.setState({ success: true, successText: 'You\'re all set!' });
                    this.onComplete(paymentMethodId);
                }
            });
        }
        if (formType === 'performance_hs_club') {
            data.plan = stripePlans.clubs.performanceHsClub;
            data.clubId = this.props.clubId;
            this.props.submitClubCheckout({ values: data, stripe: this.state.stripe }).then(() => {
                if (!this.props.subscribe.cardError) {
                    this.setState({ success: true, successText: 'You\'re all set!' });
                    this.onComplete(paymentMethodId);
                }
            });
        }
    }

    applyCoupon(couponCode) {
        this.getLineItem(couponCode);
    }

    renderLineItem() {
        const { lineItem, invoiceItems } = this.state;
        if (lineItem || invoiceItems) {
            if (invoiceItems) {
                return <LineItem invoiceItems={invoiceItems} />;
            }
            return (
                <LineItem
                    itemName={lineItem.itemName}
                    amount={lineItem.amount}
                    symbol={'$'}
                />
            );
        }
        return null;
    }

    render() {
        const { formType, subscribe, hideHeader, buttonText, success: propsSuccess, auth, titleInfoOnClick, clubName, trialAvailability, playerPaymentMethods, hideLineItem, themeV3, hideSaveCard } = this.props;
        const { success, couponCode, couponError, invoiceItems, shouldSaveCard, isUsingStripeForm } = this.state;
        const lineItem = hideLineItem ? '' : this.renderLineItem();
        const btnText = buttonText || this.getButtonText(formType);
        const showSuccess = success || propsSuccess;
        return (
            <div className={styles.checkoutForm}>
                {!hideHeader && this.getHeaderComponent(formType, titleInfoOnClick, clubName)}
                <StripeProvider stripe={this.state.stripe}>
                    <Elements fonts={[{ cssSrc: config.fontUrl }]}>
                        <InjectedCheckoutForm
                            lineItem={lineItem}
                            applyCoupon={this.applyCoupon}
                            couponCode={couponCode}
                            couponError={couponError}
                            buttonText={btnText}
                            onSuccess={this.handleCheckout}
                            disabled={success}
                            cardError={subscribe.cardError}
                            submitting={subscribe.loading || this.props.forceSubmitting}
                            user={auth.user}
                            trialAvailability={trialAvailability}
                            invoiceItems={invoiceItems}
                            formType={this.props.formType}
                            playerPaymentMethods={playerPaymentMethods}
                            shouldSaveCard={shouldSaveCard}
                            handleSaveCardChange={this.handleSaveCardChange}
                            isUsingStripeForm={isUsingStripeForm}
                            setUsingStripeForm={this.setUsingStripeForm}
                            setIsPaymentByDefaultCard={this.setIsPaymentByDefaultCard}
                            themeV3={themeV3}
                            hideSaveCard={hideSaveCard}
                        />
                    </Elements>
                </StripeProvider>
                {showSuccess && <div className="success-popup"><div className="success-text-highlight">{this.state.successText}</div></div>}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        submitMemberCheckout: (data) => dispatch(submitMemberCheckout(data)),
        submitClubCheckout: (data) => dispatch(submitClubCheckout(data)),
        submitEnterpriseClubCheckout: (data) => dispatch(submitEnterpriseClubCheckout(data)),
        updatePaymentDetails: (data) => dispatch(updatePaymentDetails(data)),
        fetchTrialContent: (trialType) => dispatch(fetchTrialContent(trialType)),

    };
}

function mapStateToProps({ subscribe, trialAvailability, auth }) {
    return { subscribe, trialAvailability, auth };
}

CheckoutForm.propTypes = {
    formType: PropTypes.string.isRequired,
    // eslint-disable-next-line react/require-default-props
    clubId: (props, propName) => {
        if (((props.formType === 'pro_club' || props.formType === 'pro_club_college' || props.formType === 'performance_hs_club') && (props[propName] === undefined || typeof (props[propName]) !== 'string'))) {
            // eslint-disable-next-line no-undef
            return new Warning(
                'No club id provided',
            );
        }
        return null;
    },

};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
